import { falTimes } from 'shared/@generated/icons/falTimes';
import { TouchableOpacity, View } from 'react-native';
import { ReactNode } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Icon } from 'shared/components/icon';
import { Text } from 'shared/components/text';

export type ModalHeaderProps = {
  title?: string;
  left?: ReactNode;
  right?: ReactNode;
  onClose?: () => void;
  closeDisabled?: boolean;
  closeAccessibilityLabel?: string;
};

export function ModalHeader({
  title,
  left,
  right,
  onClose,
  closeDisabled = false,
  closeAccessibilityLabel,
}: ModalHeaderProps) {
  const { t } = useTranslation('common');

  return (
    <View
      className={clsx(
        'border-brand-brown-dark/10 min-h-14 shrink-0 justify-center border-b py-3.5',
        left || right ? 'px-28' : 'px-12',
      )}
    >
      {!!title && (
        <Text
          accessibilityRole={'header'}
          aria-level={2}
          className={'text-brand-brown-dark text-center text-lg font-bold leading-7'}
        >
          {title}
        </Text>
      )}

      {!!left && <View className={'absolute left-2 top-2.5 z-10'}>{left}</View>}

      <View className={'absolute right-2 top-2.5 z-10 flex-row items-center'}>
        {right}
        {onClose && (
          <TouchableOpacity
            onPress={onClose}
            disabled={closeDisabled}
            accessibilityState={{ disabled: closeDisabled }}
            className={'hover:bg-brand-cream-dark rounded p-2 transition-colors'}
            accessibilityRole={'button'}
            accessibilityLabel={closeAccessibilityLabel ?? t('close')}
            testID="modal-close"
          >
            <Icon icon={falTimes} className={'text-brand-brown-dark'} />
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
}
